export default "__VITE_ASSET__BcHAjZMg__"